import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20background%20with%20golden%20geometric%20lines%20and%20soft%20glow%2C%20elegant%20premium%20texture%2C%20warm%20amber%20accents%2C%20minimal%20sophisticated%20design&width=1920&height=600&seq=cta-bg&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/80 to-background-950/95"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
          准备好开始您的
          <span className="text-primary-400">娱乐之旅</span>
          了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-400 max-w-lg mx-auto">
          立即注册金沙娱乐，享受新人专属礼遇。丰富的游戏种类、安全可靠的支付环境、24小时专属客服，尽在金沙娱乐。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-950 bg-primary-500 hover:bg-primary-400 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即注册
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-200 border border-background-500/40 hover:border-foreground-400/50 hover:text-foreground-50 rounded-xl transition-all duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}